import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/parts/quote-requests/importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/parts/quote-requests/excel-importer')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/parts/quote-requests/importer', search: true, replace: true });
    },
});
